module.exports = __webpack_public_path__ + "img/japan-pneumonia-female.d32b2f0d.png";